import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Table from '../list/components/table/main';
import ProlongForm from './components/forms/prolong-request';
import ChangeEndDateForm from './components/forms/change-end-date';
import Filters from '../../shared/filters/main';
import { Link } from 'react-router';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content guarant-approve-requests">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Guarant approve register')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<div className="clearfix position-relative">
						<Filters {...props} {...props.filters} />
					</div>
					<div className="display-flex justify-content-flex-end">
						<div>
							<button
								className="ui-btn ui-btn-primary save margin-left-5"
								onClick={props.exportCsv}
							>
								{props.intl('Export')}
							</button>
							<button
								className="ui-btn ui-btn-primary save margin-left-5"
								onClick={props.fetchData}
							>
								{props.intl('Apply')}
							</button>
							{
								props.can('guarant_register_confirm_prolong') &&
								<Link
									to='/guarant-approve-requests/create/'
									className="ui-btn ui-btn-primary save margin-left-5"
								>
									{props.intl('Create')}
								</Link>
							}
						</div>
					</div>

					<Table {...props} />
					<ProlongForm
						{...props}
						isOpen={props.isProlongPopupVisible}
						togglePopup={props.toggleProlongPopup}
					/>
					<ChangeEndDateForm
						{...props}
						isOpen={props.isChangeDatePopupVisible}
						togglePopup={props.toggleChangeDatePopup}
					/>
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		sortColumn: selectors.getSort(state),
		table: selectors.getTable(state),
		expandedIds: selectors.getExpandedIds(state),
		pagination: selectors.getPagination(state),
		expandedHistoryIds: selectors.getExpandedHistoryIds(state),
		expandedHistoryItems: selectors.getExpandedHistoryItems(state),
		calendarOfCreationDate: selectors.getCalendarOfCreationDate(state),
		progressBar: selectors.getProgressBar(state),
		changeDatePopupRequestSid: selectors.getChangeDatePopupRequestSid(state),
		changeDatePopupRequestId: selectors.getChangeDatePopupRequestId(state),
		isProlongPopupVisible: selectors.getIsProlongPopupVisible(state),
		isChangeDatePopupVisible: selectors.getIsChangeDatePopupVisible(state),
		prolongPopupRequestId: selectors.getProlongPopupRequestId(state),
		prolongRequestTypes: selectors.getProlongRequestTypes(state),
		prolongRequestReasons: selectors.getProlongRequestReasons(state),
		intl: selectors.getIntl(state),
		filters: selectors.getFilters(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/guarant-approve-register/list/main.js